import { baseApi, reportingApi } from '../../../../services/ApiController';
import {
  GET_GROUP_ANSWERS_SUCCESS,
  GET_GROUP_BY_ID_SUCCESS,
  GET_GROUP_QUESTIONS_IMPROVE_SUCCESS,
  GET_GROUP_NEWS_SUCCESS,
  GET_GROUP_QUESTIONS_SUCCESS,
  GET_GROUP_TOPICS_SUCCESS,
  GROUP_PROFILE_ANY_FAILED,
  GROUP_PROFILE_ANY_REQUEST,
} from '../constants/actions';

export const fetchGroupById = (id: string) => ({
  types: [GROUP_PROFILE_ANY_REQUEST, GET_GROUP_BY_ID_SUCCESS, GROUP_PROFILE_ANY_FAILED],
  callAPI: () => baseApi.get(`/segments/${id}`),
});

export const fetchGroupTopicsList = (queryStr: string, groupId: string) => ({
  types: [GROUP_PROFILE_ANY_REQUEST, GET_GROUP_TOPICS_SUCCESS, GROUP_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/group/${groupId}/topics${queryStr}`),
});

export const fetchGroupQuestionsList = (topicId: string, groupId: string, queryStr: string) => ({
  types: [GROUP_PROFILE_ANY_REQUEST, GET_GROUP_QUESTIONS_SUCCESS, GROUP_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/group/${groupId}/topic/${topicId}/questions${queryStr}`),
});

export const fetchGroupQuestionsImproveList = (topicId: string, groupId: string, queryStr: string) => ({
  types: [GROUP_PROFILE_ANY_REQUEST, GET_GROUP_QUESTIONS_IMPROVE_SUCCESS, GROUP_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/group/${groupId}/topic/${topicId}/how-to-improve${queryStr}`),
});

export const fetchGroupAnswersList = (questionId: string, groupId: string, queryStr: string) => ({
  types: [GROUP_PROFILE_ANY_REQUEST, GET_GROUP_ANSWERS_SUCCESS, GROUP_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/group/${groupId}/question/${questionId}/answers${queryStr}`),
});

export const fetchGroupNewsList = (groupId: string, params?: string) => ({
  types: [GROUP_PROFILE_ANY_REQUEST, GET_GROUP_NEWS_SUCCESS, GROUP_PROFILE_ANY_FAILED],
  callAPI: () => reportingApi.get(`/reports/group/${groupId}/news?${params}`),
});
